import { Step } from "react-joyride";
import {
  clickElement,
  jobContinueStep,
  LOOK_ONLY,
  mapSteps,
  NO_BACK,
  productSectionSteps,
  selectProductStep,
  totalsAndSendSteps,
  waitForSettled,
  WAIT_FOR_USER,
  withTourDefaults,
} from "./DraftPageTour.shared";
import { ADD_PRODUCT_STEP } from "modules/proposals/draft/draftTourContent";

const openJobAddressMap = async () => {
  if (document.querySelector(".tour-map-address-window")) return;
  clickElement(".tour-job-address");
  await waitForSettled(".tour-map-address-window");
};

const steps: Step[] = [
  {
    id: "job-name",
    target: ".tour-job-name",
    content: "Give your job a name.",
    data: { requireValue: ".tour-job-name input" },
    targetWaitTimeout: 3000,
    ...NO_BACK,
  },
  {
    id: "job-address",
    target: ".tour-job-address",
    content: "Click here to open Maps and add an address to your Stage.",
    ...LOOK_ONLY,
  },
  ...mapSteps(openJobAddressMap),
  jobContinueStep,
  selectProductStep,
  {
    id: "add-product",
    ...ADD_PRODUCT_STEP,
    ...WAIT_FOR_USER,
    buttons: ["back", "close"],
  },
  ...productSectionSteps({ targetWaitTimeout: 8000 }),
  ...totalsAndSendSteps,
];

const createProposalsDraftPageTourSteps: Step[] = withTourDefaults(steps);

export default createProposalsDraftPageTourSteps;
